namespace $ {
	export let $hyoo_sync_masters = [
		`sync.hyoo.ru`,
		`crowd.up.railway.app`,
		`crowd2.up.railway.app`,
	]
}
